import * as moment from "moment";

export class DateFormatValueConverter {
    toView(value, options, fallback) {
        if (!options) {
            options = { hasTimezone: true };
        }
        let format = typeof options == "string" ? options : options.format;
        const hasTimezone = typeof options == "string" ? true : options.hasTimezone;

        if (!format) {
            format = "MMMM Do YYYY";
        }
        if (value && this.hasTime(format)) {
            const date = moment(value);
            if (date.isValid()) {
                return date.format(format);
            }
            const time = moment.duration(value);
            return moment()
                .hours(time.hours())
                .minutes(time.minutes())
                .seconds(0)
                .format(format);
        } else if (value && !this.hasTime(format)) {
            return hasTimezone ? moment(value).format(format) : moment(value).utc(false).format(format);
        } else {
            return fallback ? fallback : "";
        }
    }

    private isEnabled = (granularity, dateFormat) => {
        if (typeof granularity !== 'string' || granularity.length > 1) {
            throw new TypeError('isEnabled expects a single character string parameter');
        }
        switch (granularity) {
            case 'y':
                return dateFormat.indexOf('Y') !== -1;
            case 'M':
                return dateFormat.indexOf('M') !== -1;
            case 'd':
                return dateFormat.toLowerCase().indexOf('d') !== -1;
            case 'h':
            case 'H':
                return dateFormat.toLowerCase().indexOf('h') !== -1;
            case 'm':
                return dateFormat.indexOf('m') !== -1;
            case 's':
                return dateFormat.indexOf('s') !== -1;
            default:
                return false;
        }
    }

    private hasTime = (dateFormat) => {
        return (this.isEnabled('h', dateFormat) || this.isEnabled('m', dateFormat) || this.isEnabled('s', dateFormat));
    }
}


export class FromNowValueConverter {
    toView(value) {
        return value ? moment(value).fromNow() : null;
    }

}
